/**
 * Premium custom Canvas Confetti effect.
 * Creates a floating overlay canvas that spawns bursting colorful confetti particles.
 */
export function triggerConfetti() {
    // Check if glass canvas already exists active
    if (document.getElementById('edulink-confetti-canvas')) return;

    const canvas = document.createElement('canvas');
    canvas.id = 'edulink-confetti-canvas';
    canvas.style.position = 'fixed';
    canvas.style.top = '0';
    canvas.style.left = '0';
    canvas.style.width = '100vw';
    canvas.style.height = '100vh';
    canvas.style.pointerEvents = 'none';
    canvas.style.zIndex = '99999';
    document.body.appendChild(canvas);

    const ctx = canvas.getContext('2d');
    let width = (canvas.width = window.innerWidth);
    let height = (canvas.height = window.innerHeight);

    window.addEventListener('resize', () => {
        width = canvas.width = window.innerWidth;
        height = canvas.height = window.innerHeight;
    });

    const colors = [
        '#ef4444', // EDULINK primary red
        '#3b82f6', // blue
        '#10b981', // emerald green
        '#f59e0b', // amber yellow
        '#8b5cf6', // purple
        '#ec4899', // pink
        '#06b6d4', // cyan
    ];

    const particles = [];
    const particleCount = 140;

    // Spawn point: center-bottom burst or multi-directional burst
    // Let's spawn them from the center of the screen exploding outwards, plus some from left/right sides
    // This creates an extremely majestic and premium celebratory burst!
    for (let i = 0; i < particleCount; i++) {
        const side = Math.random() < 0.4 ? 'center' : (Math.random() < 0.5 ? 'left' : 'right');
        let x, y, vx, vy;

        if (side === 'center') {
            x = width / 2;
            y = height * 0.6;
            const angle = Math.random() * Math.PI * 2;
            const speed = 4 + Math.random() * 12;
            vx = Math.cos(angle) * speed;
            vy = Math.sin(angle) * speed - 3; // burst upwards
        } else if (side === 'left') {
            x = 0;
            y = height * 0.8;
            vx = 8 + Math.random() * 12;
            vy = -(8 + Math.random() * 12);
        } else {
            x = width;
            y = height * 0.8;
            vx = -(8 + Math.random() * 12);
            vy = -(8 + Math.random() * 12);
        }

        particles.push({
            x,
            y,
            vx,
            vy,
            color: colors[Math.floor(Math.random() * colors.length)],
            rotation: Math.random() * 360,
            rotationSpeed: -10 + Math.random() * 20,
            radius: 4 + Math.random() * 6,
            shape: Math.random() < 0.6 ? 'rect' : 'circle',
            opacity: 1,
            gravity: 0.28,
            friction: 0.97,
            dimensions: {
                w: 8 + Math.random() * 8,
                h: 4 + Math.random() * 12
            }
        });
    }

    let animationFrameId;
    const startTime = Date.now();
    const duration = 2800; // 2.8 seconds celebration

    function update() {
        const elapsed = Date.now() - startTime;
        if (elapsed >= duration) {
            cancelAnimationFrame(animationFrameId);
            canvas.remove();
            return;
        }

        ctx.clearRect(0, 0, width, height);

        for (let i = 0; i < particles.length; i++) {
            const p = particles[i];

            // Apply friction and gravity
            p.vx *= p.friction;
            p.vy *= p.friction;
            p.vy += p.gravity;

            // Update positions
            p.x += p.vx;
            p.y += p.vy;

            p.rotation += p.rotationSpeed;

            // Fade out towards the end of the duration
            if (elapsed > duration * 0.6) {
                p.opacity = 1 - (elapsed - duration * 0.6) / (duration * 0.4);
            }

            ctx.save();
            ctx.translate(p.x, p.y);
            ctx.rotate((p.rotation * Math.PI) / 180);
            ctx.globalAlpha = Math.max(0, p.opacity);
            ctx.fillStyle = p.color;

            if (p.shape === 'rect') {
                ctx.fillRect(-p.dimensions.w / 2, -p.dimensions.h / 2, p.dimensions.w, p.dimensions.h);
            } else {
                ctx.beginPath();
                ctx.arc(0, 0, p.radius, 0, Math.PI * 2);
                ctx.fill();
            }

            ctx.restore();
        }

        animationFrameId = requestAnimationFrame(update);
    }

    animationFrameId = requestAnimationFrame(update);
}
